// extracted by mini-css-extract-plugin
module.exports = {"TransferPage":"TransferPage_TransferPage__2YCF0","placeholder":"TransferPage_placeholder__325Nf"};